<!--  -->
<template>
  <div>
    <el-table border align="center" :data="list">
      <el-table-column align="center" label="序号" type="index" width="60" />
      <el-table-column prop="giftCode" label="礼品编码">
        <template slot-scope="scope">
          <el-input v-model="scope.row.giftCode" @change="toFather" :disabled="disabled"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="giftName" label="礼品名称">
        <template slot-scope="scope">
          <el-input v-model="scope.row.giftName" @change="toFather" :disabled="disabled"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="giftRemark" label="礼品描述">
        <template slot-scope="scope">
          <el-input v-model="scope.row.giftRemark" @change="toFather" :disabled="disabled"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="giftUnit" label="单位">
        <template slot-scope="scope">
          <el-input v-model="scope.row.giftUnit" @change="toFather" :disabled="disabled"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="priceAmount" label="核销积分/分">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.priceAmount" @change="toFather" :disabled="disabled"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="giftPic" label="礼品图片">
        <template slot-scope="scope">
          <div>
            <UploadImage @change="(files) => changeFiles(files, scope.row)" :value="scope.row.giftPic"
              :disabled="disabled">
            </UploadImage>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import request from '@/found/utils/request';
import UploadImage from './upload_image.vue';

export default {
  components: { UploadImage },
  props: {
    value: [Array, Object],
    disabled: Boolean,
    fApi: Object,

  },
  data() {
    return {
      options: [],
      list: [{
        giftCode: '',
        giftName: '',
        giftRemark: '',
        giftUnit: '',
        priceAmount: '',
        giftPic: '',
      }],
    };
  },
  computed: {},
  mounted() { },
  methods: {

    changeFiles(files, row) {
      console.log(files, row, '888', this.list);
      this.list[0].giftPic = files[0].url;
      this.toFather();
    },

    changeEvent() {
      console.log('tt', this.list);
      this.$emit('change', this.list);
      this.$emit('input', this.list);
    },
    toFather() {
      console.log('tFather', this.list);
      this.$emit('input', this.list);
    },

  },

  watch: {
    value: {
      deep: true,
      handler(val) {
        const orgTable = [{
          giftCode: '',
          giftName: '',
          giftRemark: '',
          giftUnit: '',
          priceAmount: '',
          giftPic: '',
        }];
        console.log('tabddd', val);
        this.list = val.length ? val : orgTable;
      },
    },

  },
};
</script>

<style scoped lang="less">
.table-top {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

/deep/.vxe-header--column .vxe-cell--title {
  line-height: inherit !important;
}
</style>
